import { app } from './bootstrap/core';
import { AppService } from './app.service';
import { appState } from './app.state';
import { appComponent } from './app.component';
import { cancellationInterceptor } from './common/api/cancellationInterceptor';

app.service('appService', AppService);
app.config(appState);
app.component('app', appComponent);

// Create application-wide cache with the following set of methods:
//  {object} info() — Returns id, size, and options of cache.
//  {{*}} put({string} key, {*} value) — Puts a new key-value pair into the cache and returns it.
//  {{*}} get({string} key) — Returns cached value for key or undefined for cache miss.
//  {void} remove({string} key) — Removes a key-value pair from the cache.
//  {void} removeAll() — Removes all cached values.
//  {void} destroy() — Removes references to this cache from $cacheFactory.
app.factory('appCache', (cacheFactory) => {
  'ngInject';
  return cacheFactory.create('appCache');
});

// Apply some global configuration...
app.config(
  (
    $locationProvider,
    $urlRouterProvider,
    $httpProvider,
    $qProvider,
    $logProvider,
    envServiceProvider,
  ) => {
    'ngInject';

    // Dont throw error when promise errors are not handled
    $qProvider.errorOnUnhandledRejections(false);

    // Rely on history.pushState to change urls where supported.
    // Will fall back to hash-prefixed paths in browsers that do not support.
    $locationProvider.html5Mode(true).hashPrefix('!');

    // If the user enters a URL that doesn't match any known URL (state),
    // send them to `/` by default.
    $urlRouterProvider.otherwise('/');

    // Error handling
    $httpProvider.interceptors.push('errorInterceptor');

    // Handle Angular IE Caching issue for $http
    // Initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.get = {};
    }

    // Disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] =
      'Mon, 26 Jul 1997 05:00:00 GMT';
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
  },
);

// Registered after errorInterceptor so it runs before it in the responseError
// chain (AngularJS calls responseError handlers in reverse registration order).
app.config(cancellationInterceptor);
